import { getItem } from 'framework-listing-lib/utils/localStorage';
export function useHasDisabledAllTours() {
  return getItem('selenium.disable.onboarding_tours') === 'true';
}